export default {
  termsOfUse: 'Terms of Use',
  privacyPolicy: 'Privacy Policy',
  cookiesPolicy: 'Cookies Policy',
  careers: 'Careers',

  connectSocialMedia: 'Connect on Social Media',
  copyright: 'Copyright',
  mtgAllRightsReserved: 'Cactus Communications. All rights reserved',
};
